/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
    export class Contas {
        public static inicializar() {
            var contas = new App.Contas();
            contas.inicializarEventos();
        }
    }
}

namespace App {
    export class Contas {
        private ajax: IAjax;
        private appElectronMessage: AppElectronMessage = null;
        private consolidados: IContaConsolidado[] = null;
        private elementoConsolidadoBuscas: any = {};
        private elementoConsolidadoCompras: any = {};
        private elementoConsolidadoCaptchas: any = {};
        private contadorJustGage: ContadorJustGage = null;

        private elBtnVincularConta: JQuery = $("#btnVincularConta");
        private elBtnAcessarSniper: JQuery = $(".btn-acessar-sniper");
        private elBtnFecharSniper: JQuery = $(".btn-fechar-sniper");
        private elLinkRemoverConta: JQuery = $(".remover-conta");
        private elModalConfiguracao: JQuery = $("#modalConfigExtensao");
        private objConfiguracoesConta: ConfiguracoesConta = null;

        public inicializarEventos() {
            this.appElectronMessage = new AppElectronMessage();
            this.iniciarComunicacaoElectron();
            Util.unpinSidenav();
            this.contadorJustGage = new ContadorJustGage();
            this.elBtnVincularConta.on("click", (e) => { this.vincularConta(e) });
            this.elBtnAcessarSniper.on("click", (e) => { this.acessarSniper(e) });
            this.elBtnFecharSniper.on("click", (e) => { this.fecharSniper(e) });
            this.elLinkRemoverConta.on("click", (e) => { this.aoExcluirRegistro(e) });

            this.buscarDadosElectron();
            this.iniciarConfiguracoesDeConta(null);
        }

        private iniciarConfiguracoesDeConta(idContaEa: string) {
            const elModalConfig = $(".modal-config-extensao");
            if (!elModalConfig.length) {
                return;
            }
            this.objConfiguracoesConta = new App.ConfiguracoesConta(elModalConfig);
        }

        private iniciarComunicacaoElectron() {
            this.appElectronMessage.onMessage((request: IMensagem) => {
                switch (request.tipo) {
                    case "atualizarViewConta":
                        if (request.dados.conta) {
                            this.atualizarViewConta(request.dados.conta);
                            this.atualizarStatusConta(request.dados.conta);
                        }
                        return;
                    case "atualizarConsolidado":
                        if (request.dados.consolidado) {
                            this.atualizarConsolidado(request.dados.consolidado);
                        }
                        return;
                }
            })
        }
        private buscarDadosElectron() {
            this.appElectronMessage.sendMessage({ tipo: 'getContas', dados: { update: true } }, (contas: any) => {
                if (!contas) {
                    contas = {};
                }

                (Object as any).values(contas).forEach((conta: IDadosEa) => {
                    this.atualizarViewConta(conta);
                    this.atualizarStatusConta(conta);
                });
                console.log("contas", contas)
            })

            this.appElectronMessage.sendMessage({ tipo: 'getConsolidados', dados: null }, (consolidados: IContaConsolidado[]) => {
                this.consolidados = consolidados;
                this.atualizarViewConsolidados(this.consolidados);
            })
        }
        private atualizarViewConsolidados(consolidados: IContaConsolidado[]) {
            $.each(consolidados, (index: number, consolidado: IContaConsolidado) => {
                this.atualizarConsolidado(consolidado);
            });
        }
        private atualizarConsolidado(consolidado: IContaConsolidado) {
            console.log(consolidado);
            try {
                if (this.elementoConsolidadoBuscas.hasOwnProperty(consolidado.id)) {
                    this.elementoConsolidadoBuscas[consolidado.id].refresh(consolidado.buscas);
                } else {
                    this.elementoConsolidadoBuscas[consolidado.id] = this.contadorJustGage.inicializarCampo("contadorBuscas" + consolidado.id, "Searches", consolidado.buscas, 0, 5000);
                }

                if (this.elementoConsolidadoCompras.hasOwnProperty(consolidado.id)) {
                    this.elementoConsolidadoCompras[consolidado.id].refresh(consolidado.compras);
                } else {
                    this.elementoConsolidadoCompras[consolidado.id] = this.contadorJustGage.inicializarCampo("contadorCompras" + consolidado.id, "Sales", consolidado.compras, 0, 500);
                }

                if (this.elementoConsolidadoCaptchas.hasOwnProperty(consolidado.id)) {
                    this.elementoConsolidadoCaptchas[consolidado.id].refresh(consolidado.captchas);
                } else {
                    this.elementoConsolidadoCaptchas[consolidado.id] = this.contadorJustGage.inicializarCampo("contadorCaptchas" + consolidado.id, "Captchas", consolidado.captchas, 0, 10);
                }
            } catch (e) {
                console.log("ERROR", e);
            }

            let elementoLinhaConta = $('#conta' + consolidado.id);
            if (consolidado.lucro >= 0) {
                elementoLinhaConta.find('.lucro-down').hide();
                elementoLinhaConta.find('.lucro-up').show();
                elementoLinhaConta.find('.lucro-up .lucro').html(consolidado.lucro.toString());
            } else {
                elementoLinhaConta.find('.lucro-up').hide();
                elementoLinhaConta.find('.lucro-down').show();
                elementoLinhaConta.find('.lucro-down .lucro').html(consolidado.lucro.toString());
            }
        }
        private vincularConta(e: JQueryEventObject) {
            console.log("vincularConta", e);
            this.iniciarSessaoConta()
        }
        private acessarSniper(e: JQueryEventObject) {
            console.log("acessarSniper", $(e.currentTarget).data('idContaEa'));
            this.iniciarSessaoConta($(e.currentTarget).data('idContaEa'))
        }
        private fecharSniper(e: JQueryEventObject) {
            this.appElectronMessage.sendMessage({ tipo: 'fechar', dados: { conta: $(e.currentTarget).data('idContaEa') } }, (resposta: any) => { })
        }
        private iniciarSessaoConta(idConta: any = null) {
            this.appElectronMessage.sendMessage({ tipo: 'init', dados: { conta: idConta } }, (response: { conta: IDadosEa, consolidado: IContaConsolidado }) => {
                console.log("iniciarSessaoConta", response.conta)
                if (response.conta) {
                    this.atualizarViewConta(response.conta);
                    this.atualizarStatusConta(response.conta);
                    this.atualizarConsolidado(response.consolidado);
                }
            })
        }
        private aoExcluirRegistro(e: JQueryEventObject) {
            var textoExclusao: string = "Essa conta EA será removida/inutilizada, ou seja, <b>não poderá</b> ser utilizada <b>nessa</b> e <b>nem em outra</b> conta FUTSNIPERWEB que <b>não tenha Plano</b> ou que <b>tenha Plano Trial</b> e só poderá ser reativada mediante autorização da nossa equipe.";
            if ($(e.currentTarget).data('vendedor')) {
                textoExclusao = "Sua conta EA será desvínculada da conta FUTSNIPERWEB";
            }
            App.Util.exebirSweetConfirmacaoHtml(e, "Você tem certeza disso?", textoExclusao, "Sim, continuar", this.excluirRegistro);
            return;
        }
        private excluirRegistro(e: JQueryEventObject) {
            this.ajax = new App.Ajax();
            this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url"), { id: $(e.currentTarget).data("id") }, App.Conta.excluirRegistroNaPagina, e);
        }
        private atualizarViewConta(conta: IDadosEa) {
            let elementoConta = $(`#conta${conta.idConta}`);
            if (elementoConta.length) {
                elementoConta.find('.simbolo-clube').attr('src', conta.img)
                elementoConta.find('.coins').html(conta.coins.toLocaleString('pt-BR'))
            }
        };
        private atualizarStatusConta(conta: IDadosEa) {
            let elementoConta = $(`#conta${conta.idConta}`);
            if (elementoConta.length) {
                if (_.contains(Util.ARRAY_STATUS_CONTA_HABILITADA, conta.status)) {
                    elementoConta.find('.checklist-item').removeClass('checklist-item-warning')
                    elementoConta.find('.checklist-item').addClass('checklist-item-success')
                    elementoConta.find('.badge-status').removeClass('badge-warning')
                    elementoConta.find('.badge-status').addClass('badge-success')
                    elementoConta.find('.badge-status').html("Aberta")
                    elementoConta.find('.badge-status').show()
                    elementoConta.find('.btn-resolver-captcha').hide();
                    elementoConta.find('.btn-acessar-sniper').show()
                } else if (conta.status == Util.STATUS_CONTA_PARADA) {
                    elementoConta.find('.checklist-item').removeClass('checklist-item-success')
                    elementoConta.find('.checklist-item').addClass('checklist-item-warning')
                    elementoConta.find('.badge-status').html("")
                    elementoConta.find('.badge-status').hide()
                    elementoConta.find('.btn-resolver-captcha').hide()
                    elementoConta.find('.btn-acessar-sniper').show()
                } else {
                    var ehCaptcha = conta.status == Util.STATUS_CONTA_CAPTCHA;
                    elementoConta.find('.checklist-item').removeClass('checklist-item-success')
                    elementoConta.find('.checklist-item').addClass('checklist-item-warning')
                    elementoConta.find('.badge-status').removeClass('badge-success')
                    elementoConta.find('.badge-status').addClass('badge-warning')
                    elementoConta.find('.badge-status').html(ehCaptcha ? "Captcha Solicitado" : "Autenticação Solicitada")
                    elementoConta.find('.badge-status').show()
                    if (ehCaptcha) {
                        elementoConta.find('.btn-resolver-captcha').show()
                        elementoConta.find('.btn-acessar-sniper').hide()
                    } else {
                        elementoConta.find('.btn-resolver-captcha').hide()
                        elementoConta.find('.btn-acessar-sniper').show()

                    }
                }
            }
        };
    }
}
